import { Component, OnInit, Input } from '@angular/core'

@Component({
  standalone: false,
  selector: 'vs-address-line',
  templateUrl: './address-line.component.html',
  styleUrls: ['./address-line.component.scss'],
})
export class AddressLineComponent implements OnInit {
  @Input() address: any

  public soldToAdd
  public shipToAdd
  public endAdd
  constructor() {}

  ngOnInit(): void {
    this.soldToAdd = this.address.soldToAddress.split(';')
    this.shipToAdd = this.address.shipToAddress.split(';')
    this.endAdd = this.address.endUserAddresss.split(';')
  }
}
